import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  /* sem height 100% — sizing natural pelo conteudo dos slides.
     Antes height 100% colapsava pra 0 quando o pai (ConfigCard)
     nao tinha mais altura definida, cortando a grid de medicoes. */

  .carousel-arrow {
    z-index: 2;
    background: transparent;
    border: 1px solid #63454f;
    border-width: 0 3px 3px 0;
    padding: 6px;
    opacity: 1;
    cursor: pointer;
  }
  .custom-right-arrow {
    transform: rotate(-45deg);
  }
  .custom-left-arrow {
    transform: rotate(135deg);
  }
  .carousel-custom-button-group {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .carousel-container-custom-class {
    min-width: 100px;
    width: 100%;
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  opacity: 0.4;
  padding: 0 6px;
  :hover {
    opacity: 1;
  }
`;

export const CarouselWrapper = styled.div`
  display: flex;
  align-items: center;
`;
